<template>
  <card :class="{ invalid: cardErrorStatus }">
    <div class="box__title">물품종류</div>
    <input
      class="etc-input"
      :class="{ 'etc-input__error': !isValidateEtc }"
      type="text"
      v-model="getDeliveryOptions.item.etc.content"
      @focusout="checkValidate()"
      :autofocus="getDeliveryOptions.item.etc.content === null"
      @input="updateItemEtc(true, $event.target.value), checkValidate()"
      placeholder="(필수) 물품에 대해 설명해 주세요 (개수, 무게, 포장 상태 등)"
    />
    <div class="box__title">물품 상차 시</div>
    <div class="method">
      <custom-select
        :options="loadingPositionOptions"
        placeHolder="상차 위치 (필수항목, 택 1)"
        v-model="loadingPosition"
        @input="updateLoadingPosition(loadingPosition)"
      />
      <custom-select
        :options="loadingMethodOptions"
        placeHolder="상차 방법 (필수항목, 택 1)"
        v-model="loadingMethod"
        @input="updateLoadingMethod(loadingMethod)"
      />
    </div>
    <div class="box__title">물품 하차 시</div>
    <div class="method">
      <custom-select
        :options="unloadingPositionOptions"
        placeHolder="하차 위치 (필수항목, 택 1)"
        v-model="unloadingPosition"
        @input="updateUnLoadingPosition(unloadingPosition)"
      />
      <custom-select
        :options="unloadingMethodOptions"
        placeHolder="하차 방법 (필수항목, 택 1)"
        v-model="unloadingMethod"
        @input="updateUnLoadingMethod(unloadingMethod)"
      />
    </div>
  </card>
</template>
<script>
import customSelect from "@/components/common/CustomSelect/layout.vue";
import card from "@/components/common/card.vue";
import mixinOrder from "@/mixins/mixinOrder";
export default {
  props: ["vehicles", "submitItemValid"],
  mixins: [mixinOrder],
  components: { customSelect, card },
  data() {
    return {
      etcItemValidate: true,
      loadingPosition: null,
      unloadingPosition: null,
      loadingMethod: null,
      unloadingMethod: null,
      loadingPositionOptions: [],
      loadingMethodOptions: [],
      unloadingPositionOptions: [],
      unloadingMethodOptions: [],
    };
  },
  methods: {
    checkValidate() {
      if (
        this.getDeliveryOptions.item["etc"].content !== null &&
        this.getDeliveryOptions.item["etc"].content !== ""
      ) {
        this.etcItemValidate = true;
      } else {
        this.etcItemValidate = false;
      }
    },
  },
  computed: {
    isValidateEtc() {
      return this.etcItemValidate;
    },

    cardErrorStatus() {
      const submitValid = this.submitItemValid;
      const inputValid = this.etcItemValidate;
      let loadingUnloadingValid;
      if (
        this.loadingMethod !== null &&
        this.loadingPosition !== null &&
        this.unloadingMethod !== null &&
        this.unloadingPosition !== null
      ) {
        loadingUnloadingValid = true;
      } else {
        loadingUnloadingValid = false;
      }

      return submitValid && (!inputValid || !loadingUnloadingValid);
    },
  },
  created() {
    const vm = this;
    vm.vehicles.loadingUnloading.forEach((item) => {
      if (item.type === "LOADING_METHOD") {
        vm.loadingMethodOptions.push({
          value: item.code,
          title: item.content,
        });
      } else if (item.type === "LOADING_POSITION") {
        vm.loadingPositionOptions.push({
          value: item.code,
          title: item.content,
        });
      } else if (item.type === "UNLOADING_METHOD") {
        vm.unloadingMethodOptions.push({
          value: item.code,
          title: item.content,
        });
      } else if (item.type === "UNLOADING_POSITION") {
        vm.unloadingPositionOptions.push({
          value: item.code,
          title: item.content,
        });
      }
    });

    this.loadingMethod = this.getDeliveryOptions.loadingMethod ?? null;
    this.unloadingMethod = this.getDeliveryOptions.unloadingMethod ?? null;
    this.loadingPosition = this.getDeliveryOptions.loadingPosition ?? null;
    this.unloadingPosition = this.getDeliveryOptions.unloadingPosition ?? null;
  },
};
</script>
<style src="@/assets/css/newGlobal.css" scoped></style>
<style scoped>
.invalid {
  border: 2px solid var(--red-200) !important;
  box-sizing: border-box;
}
.method {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.etc-input {
  border: 1px solid var(--primary-200);
  background-color: var(--primary-100);
}

.etc-input:focus {
  border: 1px solid var(--primary-200) !important;
  transition-duration: 0.3s;
}

.etc-input__error {
  background-color: var(--red-100);
  border: 1px solid var(--red-200);
}

.etc-input__error:focus {
  border: 1px solid var(--red-200) !important;
  transition-duration: 0.3s;
}

@media all and (max-width: 1023px) {
  .method {
    display: flex;
    flex-direction: column;
  }
}
</style>
